export default __webpack_public_path__ + "static/media/Icon-Clock.884431cb.svg";